import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=50228046&scoped=true&"
import script from "./CategorySelector.vue?vue&type=script&lang=js&"
export * from "./CategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=50228046&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50228046",
  null
  
)

export default component.exports